import styled from "styled-components";

import { TextCell } from "@similarweb/pro-logic-components";
import { colorsPalettes } from "@similarweb/styles";

export const StyledTextCell = styled(TextCell)`
    display: inline-flex;
    padding: 4px 5px;
    border-radius: 16px;

    background-color: ${colorsPalettes.bluegrey[300]};
    text-transform: uppercase;

    user-select: none;
`;
